// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import router from './router'
import store from './store'
import App from './App'
import { sync } from 'vuex-router-sync'
import './registerServiceWorker'
import { library } from '@fortawesome/fontawesome-svg-core'

import { faEdit } from '@fortawesome/free-regular-svg-icons/faEdit'
import { faUser } from '@fortawesome/free-regular-svg-icons/faUser'
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare'
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons/faThumbsUp'
import { faThumbsDown } from '@fortawesome/free-regular-svg-icons/faThumbsDown'
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons/faCalendarAlt'

import { faCcJcb } from '@fortawesome/free-brands-svg-icons/faCcJcb'
import { faCcVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa'
import { faCcAmex } from '@fortawesome/free-brands-svg-icons/faCcAmex'
import { faCcDiscover } from '@fortawesome/free-brands-svg-icons/faCcDiscover'
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard'
import { faCcDinersClub } from '@fortawesome/free-brands-svg-icons/faCcDinersClub'

import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCookie from 'vue-cookie'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration, CaptureConsole } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import VueMeta from 'vue-meta'
import axiosRetry from 'axios-retry'
import VueCardFormat from 'vue-credit-card-validation'
import {ForceLogoutErrorCodes} from './constants'
import VueLazyload from 'vue-lazyload'
import { formatCurrency } from './utils'

import {
  LayoutPlugin,
  ModalPlugin,
  TablePlugin,
  ButtonPlugin,
  FormPlugin,
  CardPlugin,
  LinkPlugin,
  TooltipPlugin,
  FormRadioPlugin,
  NavbarPlugin,
  CarouselPlugin,
  AlertPlugin,
  VBModalPlugin,
  VBTooltipPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  DropdownPlugin,
  InputGroupPlugin,
  FormSelectPlugin,
  FormCheckboxPlugin,
  FormTextareaPlugin,
  FormTimepickerPlugin,
  FormDatepickerPlugin,
  TabsPlugin
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(NavbarPlugin)
Vue.use(TabsPlugin)
Vue.use(AlertPlugin)
Vue.use(LayoutPlugin)
Vue.use(CarouselPlugin)
Vue.use(ModalPlugin)
Vue.use(TablePlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormRadioPlugin)
Vue.use(CardPlugin)
Vue.use(LinkPlugin)
Vue.use(DropdownPlugin)
Vue.use(InputGroupPlugin)
Vue.use(TooltipPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTimepickerPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(VBModalPlugin)
Vue.use(VBTooltipPlugin)

Vue.use(VueLazyload)

library.add(faHome, faThumbsUp, faThumbsDown, faPhoneAlt, faCircle, faEdit, faSignOutAlt, faCaretRight, faCalendarAlt,
  faAngleRight, faCheckCircle, faCheck, faUser, faCaretDown, faMinus, faPlus, faSearch, faTimes, faCreditCard, faShoppingCart,
  faEnvelope, faCcVisa, faCcJcb, faCcAmex, faCcMastercard, faCcDinersClub, faCcDiscover, faArrowRight, faLock, faAngleUp,
  faAngleDown, faStar, faCaretUp, faCheckSquare, faSquare, faExclamationTriangle, faTrash, faTrashAlt, faCommentDots
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueCardFormat)

Vue.use(VueCookie)

Vue.prototype.$http = axios
Vue.config.productionTip = false

const pendingRequest = new Map() //  Request object
const CancelToken = axios.CancelToken

Vue.use(VueMeta)

Vue.filter('currency', formatCurrency)

Vue.filter('stripHTML', function(value) {
  const div = document.createElement('div')
  div.innerHTML = value
  const text = div.textContent || div.innerText || ''
  return text
})

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/'
//  Get request key
function getReqKey(config) {
  const { method, url, params } = config
  const requestKey = [method, url, JSON.stringify(params)].join('&')
  return requestKey
}

//  Cancel duplicate request
function removeReqKey(key) {
  const cancelToken = pendingRequest.get(key)
  cancelToken(key)
  pendingRequest.delete(key)
}

axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.isSessionStarted) {
      config.headers.common['Authorization'] = 'Token ' + store.state.token
    }

    if (store.state.profilerEnabled) {
      config.headers.common['Profiler-Enabled'] = 'true'
    }

    if (config.cancelRequest) {
      //  Get request key
      let requestKey = getReqKey(config)

      //  Determine whether it is a duplicate request
      if (pendingRequest.has(requestKey)) { //  It's a repeated request
        removeReqKey(requestKey) // Cancel and remove
      }
      //  Set up cancelToken
      config.cancelToken = new CancelToken(function executor(cancel) {
        pendingRequest.set(requestKey, cancel)
      })
    }

    return config
  },
  error => {
    // Do something with request error
    console.log(error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error)
    if (error.response && (ForceLogoutErrorCodes.indexOf(error.response.status) >= 0)) {
      store.commit('logout')
    }
    return Promise.reject(error)
  }
)

let retryCounters = {}

axiosRetry(axios, {
  retries: 999999999, // really big number - we'll implement retries manually
  shouldResetTimeout: true,
  retryCondition: function(error) {
    let shouldRetry = false

    if (!axios.isCancel()) {
      shouldRetry = axiosRetry.isIdempotentRequestError(error) ||
        (error.response && error.config.method.toUpperCase() === 'POST' &&
          [500, 501, 502, 503].indexOf(error.response.status) > -1 && !error.config.url.endsWith('/input/')) ||
        ((axiosRetry.isNetworkError(error) || (error.response && error.response.status === 423)) &&
          error.config.method.toUpperCase() === 'GET')
      if (shouldRetry) {
        if (!error.response || error.response.status !== 423) {
          const maxRetries = Number(process.env.VUE_APP_MAX_RETRIES)
          const key = error.config.method + ':' + error.config.url
          const retryCount = retryCounters[key] || 0

          if (retryCount >= maxRetries) {
            shouldRetry = false
            delete retryCounters[key]
          } else {
            retryCounters[key] = retryCount + 1
          }
        }

        if (shouldRetry) {
          console.log('request retried', JSON.stringify(error))
        }
      }
    }
    return shouldRetry
  },
  retryDelay: axiosRetry.exponentialDelay
})

sync(store, router)

if (process.env.VUE_APP_SENTRY_DSN) {
  let performanceMonitoring = { tracingOptions: {}, options: {} }
  let enablePM = process.env.ENABLE_SENTRY_PM
  if (enablePM) {
    performanceMonitoring.tracingOptions = {
      tracingOrigins: [process.env.VUE_APP_API_URL.split('//')[1]]
    }
    performanceMonitoring.options = {
      tracesSampleRate: process.env.SENTRY_TRACK_SAMPLE_RATE || 0.1,
      trackComponents: true,
      timeout: 5000,
      hooks: ['activate', 'create', 'destroy', 'mount', 'update']
    }
  }
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({Vue, attachProps: true}), new Integrations.BrowserTracing(
      performanceMonitoring.tracingOptions
    ),
    new CaptureConsole({levels: ['error']})],
    debug: process.env.VUE_APP_SENTRY_DEBUG_MODE === 'true',
    ignoreErrors: [
      'Non-Error promise rejection captured',
      'Non-Error promise rejection captured with value',
      'missing session', // ignoring this because its a warning
      'Navigating to current location',
      'NavigationDuplicated',
      'timeout of 60000ms exceeded',
      'can\'t redefine non-configurable property "userAgent"', // ignoring this because of Firefox
      'Request failed with status code 401' // ignoring because it's only a warning from axios. error is handled
    ],
    ...performanceMonitoring.options
  })
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
